export function nextScrollTop(scrollTop: number, clientHeight: number, scrollHeight: number, direction: 1 | -1): number | null {
  const max = Math.max(0, scrollHeight - clientHeight);
  if (max <= 8) return null;
  if (direction > 0 && scrollTop >= max - 8) return null;
  if (direction < 0 && scrollTop <= 8) return null;
  return Math.min(max, Math.max(0, scrollTop + clientHeight * 0.86 * direction));
}

export function nextPdfPage(page: number, pageCount: number, direction: 1 | -1): number | null {
  if (pageCount <= 1) return null;
  const next = page + direction;
  if (next < 0 || next >= pageCount) return null;
  return next;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
